import { Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { AuthService } from '@core/auth.service';

export interface DefaultMessage {
  message: {
    line_1: string;
    line_2?: string; // Optional property
  };
  style: {
    icon: string;
    type: string;
    duration?: number; // Optional property
  };
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private authService: AuthService) { }

  handleUnexpectedError(): void {
    const defaultMsg = {
      message: {
        line_1: 'Something went wrong. Please try again',
        line_2: '',
      },
      style: {
        icon: 'tick circle error.svg',
        type: 'Error',
      },
    };
    this.showTranslatedMessage('1026', defaultMsg);
  }

  handleErrorWithTranslation(messageCode: string,
    defaultErrorDetails: {
      line_1: string;
      line_2?: string; // Optional property
      icon?: string; // Optional property
      type?: string; // Restrict to specific types
      duration?: number; // Optional property
    },) {
    const defaultMsg: DefaultMessage = {
      message: {
        line_1: defaultErrorDetails?.line_1,
        line_2: defaultErrorDetails?.line_2 || '', // Use provided line_2 or default to an empty string
      },
      style: {
        icon: defaultErrorDetails?.icon || 'tick circle error.svg', // Use provided icon or default
        type: defaultErrorDetails?.type || 'Error', // Use provided type or default to 'Error'
      },
    };
    this.showTranslatedMessage(messageCode, defaultMsg);
  }

  async showTranslatedMessage(messageCode: string | null, defaultMsg: DefaultMessage): Promise<string | null> {
    try {
      const translatedMsg = messageCode ? await this.authService.getConstantsMsg(messageCode) : null;
      this.authService.showToastMessage(translatedMsg, defaultMsg);
    } catch (err) {
      this.authService.showToastMessage(null, defaultMsg);
      return null;
    }
  }


  logError(message: string, error?: Data): { message: string; timestamp: string; error: Data } {
    const log = {
      message,
      timestamp: new Date().toISOString(),
      error: error ? this.formatError(error) : null,
    };
    return log;
  }

  private formatError(error: any): any {
    if (error instanceof Error) {
      return {
        name: error.name,
        message: error.message,
        stack: error.stack,
      };
    }

    return error;
  }
}
